/**
 * 供应商绩效常量定义
 */
import { SupplierPerformanceLevel } from './enums';

/**
 * 绩效等级选项
 */
export const SUPPLIER_PERFORMANCE_LEVEL_OPTIONS = [
  { value: SupplierPerformanceLevel.A, label: 'A级（优选）', color: 'success' },
  { value: SupplierPerformanceLevel.B, label: 'B级（合格）', color: 'processing' },
  { value: SupplierPerformanceLevel.C, label: 'C级（观察）', color: 'warning' },
  { value: SupplierPerformanceLevel.D, label: 'D级（淘汰）', color: 'error' },
] as const;

/**
 * 绩效等级文本映射
 */
export const SUPPLIER_PERFORMANCE_LEVEL_TEXT_MAP: Record<SupplierPerformanceLevel, string> = {
  [SupplierPerformanceLevel.A]: 'A级（优选）',
  [SupplierPerformanceLevel.B]: 'B级（合格）',
  [SupplierPerformanceLevel.C]: 'C级（观察）',
  [SupplierPerformanceLevel.D]: 'D级（淘汰）',
};

/**
 * 绩效等级颜色映射
 */
export const SUPPLIER_PERFORMANCE_LEVEL_COLOR_MAP: Record<SupplierPerformanceLevel, string> = {
  [SupplierPerformanceLevel.A]: 'success',
  [SupplierPerformanceLevel.B]: 'processing',
  [SupplierPerformanceLevel.C]: 'warning',
  [SupplierPerformanceLevel.D]: 'error',
};

/**
 * 绩效权重配置（固定）
 */
export const PERFORMANCE_WEIGHTS = {
  /** 交期达成率权重 */
  DELIVERY: 0.30,
  /** 来料合格率权重 */
  QUALITY: 0.40,
  /** 服务评分权重 */
  SERVICE: 0.15,
  /** 索赔率权重 */
  CLAIM: 0.15,
} as const;

/**
 * 等级阈值
 */
export const PERFORMANCE_LEVEL_THRESHOLDS = {
  /** A级阈值 >= 90 */
  A: 90,
  /** B级阈值 >= 80 */
  B: 80,
  /** C级阈值 >= 70 */
  C: 70,
} as const;
